// extracted by mini-css-extract-plugin
export default {"header":"Header_header__b9EQ9","logo":"Header_logo__TT5FV","website":"Header_website__Mg18k"};